import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { InputTextarea } from 'primereact/inputtextarea';
import { forwardRef } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { GetInputClassName } from '../../_utils/get-input-class-name.js';
import { getPlaceholder } from '../../_utils/get-placeholder.js';
import { InputWrapper } from '../InputWrapper/InputWrapper.js';

function TextAreaComponent(props, ref) {
  const {
      name,
      required,
      bulkMode,
      errorMessage,
      horizontal,
      className: classNameProps,
      onBlur: _,
      labelHidden: __,
      labelClassName: ___,
      wrapperClassName: ____
    } = props,
    restProps = __rest(props, ["name", "required", "bulkMode", "errorMessage", "horizontal", "className", "onBlur", "labelHidden", "labelClassName", "wrapperClassName"]);
  const placeholder = getPlaceholder(props);
  const formContext = useFormContext();
  const isControlled = typeof restProps.value !== 'undefined';
  if (isControlled || !formContext) {
    return jsx(InputWrapper, Object.assign({}, props, {
      children: jsx(InputTextarea, Object.assign({}, restProps, {
        className: GetInputClassName({
          basicClassName: classNameProps,
          horizontal,
          invalidState: Boolean(errorMessage)
        }),
        placeholder: placeholder,
        ref: ref
      }))
    }));
  }
  return jsx(Controller, {
    name: name !== null && name !== void 0 ? name : '',
    control: formContext.control,
    rules: {
      required: required && !bulkMode
    },
    render: _ref => {
      let {
        field,
        fieldState
      } = _ref;
      return jsx(InputWrapper, Object.assign({
        field: field,
        fieldState: fieldState
      }, props, {
        children: jsx(InputTextarea, Object.assign({}, restProps, field, {
          className: GetInputClassName({
            basicClassName: classNameProps,
            horizontal,
            invalidState: fieldState.invalid
          }),
          placeholder: placeholder,
          ref: ref
        }))
      }));
    }
  });
}
const TextArea = /*#__PURE__*/forwardRef(TextAreaComponent);

export { TextArea };
